import React from 'react';

export default function Play() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 75 75" fill="none">
      <path d="M70.3125 37.5C70.3144 38.2958 70.1104 39.0785 69.7202 39.7721C69.3301 40.4657 68.767 41.0465 68.0859 41.458L25.875 67.2803C25.1633 67.7161 24.3482 67.954 23.5139 67.9694C22.6796 67.9849 21.8562 67.7773 21.1289 67.3682C20.4085 66.9654 19.8084 66.378 19.3903 65.6664C18.9722 64.9548 18.7512 64.1447 18.75 63.3193V11.6807C18.7512 10.8553 18.9722 10.0452 19.3903 9.3336C19.8084 8.62201 20.4085 8.03461 21.1289 7.63183C21.8562 7.2227 22.6796 7.01514 23.5139 7.03059C24.3482 7.04604 25.1633 7.28394 25.875 7.71972L68.0859 33.542C68.767 33.9535 69.3301 34.5343 69.7202 35.2279C70.1104 35.9215 70.3144 36.7042 70.3125 37.5Z" fill="currentColor" />
    </svg>
  );
}
